import axios from "axios";
import Config from "../../misc/Config";

const API_URL = Config.PROXY_URL + "/seminar-date";

const state = {
  inhouseSales: null,
  openSales: null,
  bookingCount: null,
  clientCount: null,
  seminarCount: null,
};
const getters = {
  inhouseSales: (state) => state.inhouseSales,
  openSales: (state) => state.openSales,
  bookingCount: (state) => state.bookingCount,
  clientCount: (state) => state.clientCount,
  seminarCount: (state) => state.seminarCount,
};
const actions = {
  async fetchSalesStatistic({ commit }, search) {
    const response = await axios.get(API_URL + "/sales-statistic");
    commit("setInhouseSales", response.data.inhouseSales);
    commit("setOpenSales", response.data.openSales);
    commit("setBookingCount", response.data.bookingCount);
  },
  fetchClientAndSeminarCount({ commit }, search) {
    return axios.get(Config.PROXY_URL + "/stats/info").then((response) => {
      commit("setClientCount", response.data.countAll.bookings);
      commit("setSeminarCount", response.data.seminarCount);
    });
  },
};
const mutations = {
  setInhouseSales: (state, inhouseSales) => (state.inhouseSales = inhouseSales),
  setOpenSales: (state, openSales) => (state.openSales = openSales),
  setBookingCount: (state, bookingCount) => (state.bookingCount = bookingCount),
  setClientCount: (state, clientCount) => (state.clientCount = clientCount),
  setSeminarCount: (state, seminarCount) => (state.seminarCount = seminarCount),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
